import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export function ScrollToTop() {
  const {
    pathname,
    hash,
    key
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target) {
        target.scrollIntoView({
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash, key]);
  return null;
}